import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=5c7f884b&scoped=true&"
import script from "./Popup.vue?vue&type=script&lang=js&"
export * from "./Popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f884b",
  null
  
)

export default component.exports